export default {
  1: '#F4811F',
  2: '#7FC35D',
  3: '#9FD2F1',
  4: '#F498B1',
  5: '#ECE70A',
  6: '#009E4C',
  7: '#B199CA',
  8: '#00BFF2',
  9: '#F05A72',
  10: '#D9C496',
  11: '#34BAA5',
  12: '#FFC10E',
  13: '#8A72B3',
  14: '#ACB671',
  15: '#686868'
};
